import React from 'react'
import Servicedetail from '../components/servicedetail/Servicedetail'
import Pagetitle from '../components/pagetitle/Pagetitle'
import ecommereimg from '../Images/gaytsby-e0fc01a9a0a5c4198be67d2cf16e935c.png'
export default function Ecommerce() {
  const servicetechnologies = ['Adobe Photoshop',
    'Adobe illustrator',
    'Adobe XD']
  return (
    <div>
      <Pagetitle pagename="Ecommerce" parentpage="Home" />
      <Servicedetail serviceimg={ecommereimg} technologies={servicetechnologies} servicesabout="Our professional Market Expert will solve your problem related to Online Shopping. We will provide you solution related to Amazon and Shopify Stores." />
    </div>
  )
}
